import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COUNTRY_CODES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  AddressInfoDto,
  BackResponse,
  BackResponseFailure,
  PickupPoint,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}pickuppoints/coord`;

export interface GetClaimPickupPointsByCarrierQueryArgs {
  countryCode: COUNTRY_CODES;
  address: AddressInfoDto;
  carrierCompany: string;
  productType: string;
  sellerId: string;
  maxDistance?: number;
  claimId: string;
}

export const getClaimPickupPointsByCarrierRequest = ({
  countryCode,
  address,
  carrierCompany,
  productType,
  sellerId,
  maxDistance = 200,
  claimId,
}: GetClaimPickupPointsByCarrierQueryArgs): ApiRequestDescriptor => {
  const payload = {
    CountryCode: countryCode,
    carrierCompany: carrierCompany === 'chrono' ? 'Chronopost' : carrierCompany,
    distance: maxDistance,
    maxPickupPoint: 10,
    productType,
    sellerId,
    address,
    claimId,
  };

  const parameters = pickBy(payload, identity);

  return {
    url: buildUrl(ENDPOINT, parameters as Record<string, string>),
    config: { method: SUPPORTED_METHODS.GET },
  };
};

export const getClaimPickupPointsByCarrierQuery = async (
  args: GetClaimPickupPointsByCarrierQueryArgs,
): Promise<BackResponse<PickupPoint[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<PickupPoint[]>>(
      getClaimPickupPointsByCarrierRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
